import * as RPopover from '@radix-ui/react-popover'
import { FC } from 'react'

export type PopoverCloseProps = RPopover.PopoverCloseProps

const PopoverClose: FC<PopoverCloseProps> = (props) => <RPopover.Close asChild {...props} />

export default PopoverClose
